<template>
    <div class="fhv-centent"  >
        <h4 class="title-topic">SNMP Setting</h4>
          <el-form :model="form"
            :rules="checkForm"
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            v-loading="loading"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable SNMP :" >
                <el-switch v-model="form.snmpEnable" ></el-switch>
            </el-form-item>
            <div v-if="form.snmpEnable">
                <el-form-item label="Name:" prop="snmpName">
                    <el-input v-model="form.snmpName"></el-input>
                </el-form-item>
                <el-form-item label="Location:" prop="snmpLocation">
                    <el-input v-model="form.snmpLocation"></el-input>
                </el-form-item>
                <el-form-item label="Contanct:" prop="snmpContact">
                    <el-input v-model="form.snmpContact"></el-input>
                </el-form-item>
                <el-form-item label="Read/Write Conmmunity:" prop="snmpRWCommunity">
                    <el-input v-model="form.snmpRWCommunity"></el-input>
                </el-form-item>
                <el-form-item label="Read-Only Community:" prop="snmpROCommunity">
                    <el-input v-model="form.snmpROCommunity"></el-input>
                </el-form-item>
            </div>
            
            <el-form-item >
                <el-button type="primary"  @click="save">Apply</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            form:{
                snmpEnable:false,
                snmpName:'',
                snmpLocation:'',
                snmpContact:'',
                snmpRWCommunity:'',
                snmpROCommunity:''
            },
            checkForm:{
                snmpName:[
                    { required: true, message: 'Name cannot be empty.', trigger: 'blur' },
                    { min: 1, max: 63, message: 'Name length rang [1~63]', trigger: 'blur' }
                ],
                snmpLocation:[
                    { required: true, message: 'Location cannot be empty.', trigger: 'blur' },
                    { min: 1, max: 63, message: 'Location length rang [1~63]', trigger: 'blur' }
                ],
                snmpContact:[
                    { required: true, message: 'Contanct cannot be empty.', trigger: 'blur' },
                    { min: 1, max: 63, message: 'Contanct length rang [1~63]', trigger: 'blur' }
                ],
                snmpRWCommunity:[
                    { required: true, message: 'Read/Write Conmmunity cannot be empty.', trigger: 'blur' },
                    { min: 1, max: 63, message: 'Read/Write Conmmunity length rang [1~63]', trigger: 'blur' }
                ],
                snmpROCommunity:[
                    { required: true, message: 'Read-Only Community cannot be empty.', trigger: 'blur' },
                    { min: 1, max: 63, message: 'Read-Only Community length rang [1~63]', trigger: 'blur' }
                ]
            }
        }
    },
    created(){
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"GET_WEB_SNMP"
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.form.snmpEnable = response.data.snmpEnable
                    this.form.snmpName = response.data.snmpName
                    this.form.snmpLocation = response.data.snmpLocation
                    this.form.snmpContact = response.data.snmpContact
                    this.form.snmpRWCommunity = response.data.snmpRWCommunity
                    this.form.snmpROCommunity = response.data.snmpROCommunity
                }
                else
                    this.$message.error(`GET SNMP data failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        setData(){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_SNMP",
                snmpEnable:this.form.snmpEnable,
                snmpName:this.form.snmpName,
                snmpLocation:this.form.snmpLocation,
                snmpContact:this.form.snmpContact,
                snmpRWCommunity:this.form.snmpRWCommunity,
                snmpROCommunity:this.form.snmpROCommunity
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration is success!')
                }
                else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Configuration failed! Network connection error!')
            })
        },
        save(){
            this.$refs['forms'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    console.log('error submit!!')
                    return false;
                }
            })
        }
    },
}
</script>





